import React, { useCallback, useContext, useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DynamicTable from "../../../components/tables/dynamic-table1";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { productDeleteAction } from "../../../redux/actions/product-action";
import { DataContext } from "../../../components/layouts/main-layout";
import { useHotkeys } from "react-hotkeys-hook";
import moment from "moment";
import PaymentInOutFilter from "../../../components/tables/table-filter/payment-in-out-filter";
import { paymentOutTableAction } from "../../../redux/actions/purchase-action";
import { formatString } from "../../../components/helper-components/helper-function";
import StatusIcons from "../../../assets/icons/check-icon";
import DynamicTransactionTable from "../../../components/tables/dynamic-transaction-table";
import { TimerIcon } from "lucide-react";
import UpiICon from "../../../assets/icons/pay-method-icons/upi-icon";
import CardIcon from "../../../assets/icons/pay-method-icons/card-icon";
import CashIcon from "../../../assets/icons/pay-method-icons/cash-icon";
import BankIcon from "../../../assets/icons/pay-method-icons/bank-icon";
import ChequeIcon from "../../../assets/icons/pay-method-icons/cheque-icon";
import InvoiceUnsettled from "../../../assets/icons/pay-method-icons/invoice-unsettled-icon";
import ExclamatoryIcon from "../../../assets/icons/pay-method-icons/exclamatory-icon";
import InvoiceSettled from "../../../assets/icons/pay-method-icons/invoice-settled-icon";
import TickIcon from "../../../assets/icons/pay-method-icons/tick-icon";
import RupeeIcon from "../../../assets/icons/pay-method-icons/rupee-icon";
import ProgressIcon from "../../../assets/icons/pay-method-icons/progress-icon";
import Component1 from "../../../components/sales-section/payment-in-out-statistics/component1";
import Component2 from "../../../components/sales-section/payment-in-out-statistics/component2";
import Component3 from "../../../components/sales-section/payment-in-out-statistics/component3";
import PaymentStatistics from "../../../components/sales-section/payment-in-out-statistics/payment-statistics";
import formatCurrency from "../../../components/sales-section/payment-in-out-statistics/format-currency";
import BadgesComponent from "../../../components/tables/badges-component";

const PurchasePaymentOut = () => {
  const [heading, setHeading] = useState([]);

  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const [paymentList, setPaymentList] = useState([]);
  const [statistics, setStatistics] = useState({});
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [reload, setReload] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    selectColumn: "pot_order_status",
    inputValue: "",
    from: "",
    to: "",
  });

  useEffect(() => {
    dispatch(
      paymentOutTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
    const data = localStorage.getItem("ModPermission");

    if (data) {
      const parsed = JSON.parse(data);
      console.table(parsed);
      const PayOutData = parsed.find((obj) => obj?.payment_out_list);
      if (PayOutData?.payment_out_list) {
        setHeading(PayOutData.payment_out_list);
      }
    }
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setPaymentList(data?.data?.orderList);
    setDataCount(data?.data?.totalCount);
    setStatistics(data?.data?.stats);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };

  const navigate = useNavigate();

  const tableBodyData = paymentList?.map((item) => {
    return {
      id: item?.pot_id,
      pot_invoice_number:
        <span className="fw_500">{item?.pot_invoice_number ?? "--"}</span> ??
        "--",
      cmr_name: item?.cmr_name ? item?.cmr_name : "--",
      pot_posting_date: item?.pot_posting_date
        ? moment(item?.pot_posting_date).format("MMM D, YYYY")
        : "--",
      // order_status: item?.pot_order_status ? (
      //   <span
      //     style={{
      //       backgroundColor:
      //         item?.pot_order_status === "paid"
      //           ? "var(--success-color-opacity)" // Fully opaque success color
      //           : "var(--danger-color-opacity)", // F51D00 with approximately 15% opacity
      //     }}
      //     className={`${
      //       item?.pot_order_status === "paid" ? "text-027A48 " : "text-F51D00 "
      //     } fw_500 flex items-center gap-2 px-3 py-1 rounded-full w-fit text-xs`}
      //   >
      //     <StatusIcons status={item?.pot_order_status} />
      //     {formatString(item?.pot_order_status)}
      //   </span>
      // ) : (
      //   "--"
      // ),
      order_status: <BadgesComponent status={item?.pot_order_status} />,

      pot_order_status: item?.pot_order_status,
      pot_current_payment:
        "₹ " + parseFloat(item?.pot_current_payment ?? 0)?.toFixed(2),
      created_date: item?.created_date
        ? moment(item?.created_date).format("DD MMM YYYY")
        : "--",
      update_date: item?.update_date
        ? moment(item?.update_date).format("DD MMM YYYY")
        : "--",
      created_user_name: item?.created_user_name ?? "--",
      updated_user_name: item?.updated_user_name ?? "--",
      store_code: item?.store_code ?? "--",
      store_name: item?.store_name ?? "--",
      store_type: item?.store_type ?? "--",
      firm_name: item?.firm_name ?? "--",
      cmr_code: item?.cmr_code ?? "--",
    };
  });

  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const filterby = showFilter ? (
    <PaymentInOutFilter
      setCurrentPage={setCurrentPage}
      filterData={filterData}
      setFilterData={setFilterData}
      setShowFilter={setShowFilter}
    />
  ) : null;
  useHotkeys("escape", () => {
    setShowFilter(false);
  });

  const paymentArray = [
    {
      conClass: "bg-[var(--trans-stats-con-sales-bg)] ",
      label: "Cash",
      value: statistics?.payment_methods_summary?.Cash?.total_amount,
      desc: statistics?.payment_methods_summary?.Cash?.percent,
      icon: <CashIcon />,
      iconConClass: "bg-[var(--list-payMet-cash-bg)]",
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass: "bg-[var(--trans-stats-con-sales-bg)]",
      label: "Card ",
      value: statistics?.payment_methods_summary?.["Credit Card"]?.total_amount,
      desc: statistics?.payment_methods_summary?.["Credit Card"]?.percent,
      icon: <CardIcon />,
      iconConClass: "bg-[var(--list-payMet-card-bg)]",
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass: "bg-[var(--trans-stats-con-sales-bg)]",
      label: "UPI ",
      value: statistics?.payment_methods_summary?.UPI?.total_amount,
      desc: statistics?.payment_methods_summary?.UPI?.percent,
      icon: <UpiICon />,
      iconConClass: "bg-[var(--list-payMet-upi-bg)] ",
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass: "bg-[var(--trans-stats-con-sales-bg)]",
      label: "Bank",
      value:
        statistics?.payment_methods_summary?.["Bank Transfer"]?.total_amount,
      desc: statistics?.payment_methods_summary?.["Bank Transfer"]?.percent,
      icon: <BankIcon />,
      iconConClass: "bg-[var(--list-payMet-bank-bg)]",
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass: "bg-[var(--trans-stats-con-sales-bg)]",
      label: "Cheque",
      value: statistics?.payment_methods_summary?.Cheque?.total_amount,
      desc: statistics?.payment_methods_summary?.Cheque?.percent,
      icon: <ChequeIcon />,
      iconConClass: "bg-[var(--list-payMet-credit-bg)]",
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];

  const summaryArray = (
    <div className="px-[24px] pt-[16px] flex space-x-[15px]">
      <Component1
        value={statistics?.total_payments?.total_amount}
        transactions={statistics?.total_payments?.total_transactions}
        vendorValue={statistics?.total_payments?.vendor?.amount}
        vendorPercent={statistics?.total_payments?.vendor?.percent}
        customerValue={statistics?.total_payments?.customer?.amount}
        customerPercent={statistics?.total_payments?.customer?.percent}
        progressPercent={statistics?.total_payments?.vendor?.percent}
      />
      <Component2
        title={"Invoices Settled"}
        bg={"#DCFCE7"}
        highlightColor={"#10B981"}
        progressColor={"#37C195"}
        icon1={<TickIcon />}
        icon2={<InvoiceSettled />}
        statusValue={statistics?.invoices_settled?.completed_count} //backend
        status={"Completed"}
        value={statistics?.invoices_settled?.completed_amount} //backend
        progressLable={"Completion Rate"}
        progressPercent={statistics?.invoices_settled?.completion_rate} //backend
        settledValue={statistics?.invoices_settled?.last_settled} //backend
        settled={"Last Settled"}
      />
      <Component2
        title={"Invoices Unsettled"}
        bg={"#FFEDD5"}
        highlightColor={"#F97316"}
        progressColor={"#F59E0B"}
        icon1={<ExclamatoryIcon />}
        icon2={<InvoiceUnsettled />}
        progressLable={"Pending Rate"}
        status={"Pending"}
        value={statistics?.invoices_unsettled?.pending_amount} //backend
        progressPercent={statistics?.invoices_unsettled?.pending_rate} //backend
        statusValue={statistics?.invoices_unsettled?.pending_count} //backend
        settledValue={statistics?.invoices_unsettled?.oldest_pending} //backend
        settled={"Oldest"}
      />
      <Component3
        value={statistics?.payment_success_rate?.on_time}
        latePayment={statistics?.payment_success_rate?.late}
        SuccessPercent={statistics?.payment_success_rate?.success_rate}
        progressPercent={statistics?.payment_success_rate?.success_rate}
      />
    </div>
  );

  return (
    <InnerLayout
      list={true}
      module="product"
      permissionFn={permissionFn}
      onclkFn={() => navigate("/add-product")}
      title="Payment Out"
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <>
          <DynamicTransactionTable
            actionsPermissions={{
              edit: ["pending"],
              delete: ["pending"],
              send: ["open", "paid", "pending"],
              print: ["open", "paid", "pending"],
            }}
            transactionKey="pot"
            menu={true}
            is_checkbox_req={false}
            edit={false}
            onClickItemFn={(id) => navigate(`/view-payment-out/${id}`)}
            list={true}
            onclkFn={() => {
              navigate("/add-purchase-payment-out");
            }}
            transaction_type="stock_transfer"
            permissionFn={permissionFn}
            module={"product"}
            path="payment-out"
            id_name="item_id"
            reload={reload}
            setReload={setReload}
            loading={loading}
            setLoading={setLoading}
            deleteAction={productDeleteAction}
            label="Payment In"
            showFilter={showFilter}
            filterFn={handleFilterClick}
            setFilterData={setFilterData}
            filterData={filterData}
            paginationProps={paginationProps}
            tableHeading={heading}
            tableBodyData={tableBodyData}
            placeholder="Search"
            filterBy={filterby}
            initialFilter={{
              sort_by: "",
              sort_order: "",
              selectColumn: "pot_invoice_number",
              inputValue: "",
              pot_order_status: "",
              from: "",
              to: "",
            }}
            paymentArray={PaymentStatistics(paymentArray)}
            summaryArray={summaryArray}
          />
        </>
      )}
    </InnerLayout>
  );
};

export default PurchasePaymentOut;
const tableHeading = [
  {
    label: "DOCUMENT NUMBER",
    value: "pot_invoice_number",
    display: true,
    column: true,
  },
  {
    label: "VENDOR / CUSTOMER NAME",
    value: "cmr_name",
    display: true,
    column: true,
  },
  {
    label: "POSTING DATE",
    value: "pot_posting_date",
    display: true,
    column: true,
  },
  {
    label: "STATUS",
    value: "pot_order_status",
    display: false,
    column: false,
  },
  {
    label: "AMOUNT",
    value: "pot_current_payment",
    display: true,
    column: false,
    className: "justify-end pe-5",
  },
  {
    label: "ACTION",
    value: "",
    column: false,
  },
];
